// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2IefQ","content":"styles_content__2POUc","checkbox":"styles_checkbox__3_3DO","checkboxLabel":"styles_checkboxLabel__1OkG2"};